<template>
  <v-card variant="flat" class="platform-email__panel">
    <div class="platform-email__panel-header">
      <div>
        <h2>{{ $t("admin.platformEmail.templates.title") }}</h2>
        <p>{{ $t("admin.platformEmail.templates.subtitle") }}</p>
      </div>
      <v-chip color="secondary">RO · EN · RU</v-chip>
    </div>

    <v-skeleton-loader v-if="loading && !templates.length" type="article, article" />
    <div v-else class="platform-email__template-workspace">
      <v-alert v-if="errorMessage" type="error">{{ errorMessage }}</v-alert>
      <v-alert v-if="successMessage" type="success">{{ successMessage }}</v-alert>

      <div class="platform-email__template-selectors">
        <v-select v-model="selectedTemplateKey" :items="templateItems" :label="$t('admin.platformEmail.templates.fields.template')" />
        <v-select v-model="selectedLocale" :items="localeItems" :label="$t('admin.platformEmail.templates.fields.locale')" />
        <v-select v-model="selectedVersion" :items="versionItems" :label="$t('admin.platformEmail.templates.fields.version')" />
      </div>

      <div class="platform-email__variable-strip">
        <span>{{ $t("admin.platformEmail.templates.allowedVariables") }}</span>
        <v-chip v-for="variable in allowedVariables" :key="variable" size="x-small" color="secondary">
          {{ formatVariable(variable) }}
        </v-chip>
      </div>

      <v-text-field v-model="editor.subject" :label="$t('admin.platformEmail.templates.fields.subject')" />
      <v-textarea v-model="editor.textBody" :label="$t('admin.platformEmail.templates.fields.textBody')" rows="7" auto-grow />
      <v-textarea v-model="editor.htmlBody" :label="$t('admin.platformEmail.templates.fields.htmlBody')" rows="10" auto-grow class="platform-email__code-field" />

      <div class="platform-email__actions">
        <v-btn color="primary" :loading="saving" prepend-icon="mdi-content-save-edit-outline" @click="saveDraft">
          {{ $t("admin.platformEmail.actions.saveDraft") }}
        </v-btn>
        <v-btn variant="tonal" :loading="previewing" prepend-icon="mdi-eye-outline" @click="openPreview">
          {{ $t("admin.platformEmail.actions.preview") }}
        </v-btn>
        <v-btn color="success" variant="tonal" :disabled="!canActivate" :loading="activating" prepend-icon="mdi-check-decagram-outline" @click="activateVersion">
          {{ $t("admin.platformEmail.actions.activate") }}
        </v-btn>
      </div>
    </div>

    <v-navigation-drawer v-model="previewOpen" location="right" temporary width="520" class="platform-email__preview-drawer">
      <div class="platform-email__preview-header">
        <div>
          <h2>{{ $t("admin.platformEmail.templates.previewTitle") }}</h2>
          <p>{{ preview?.subject }}</p>
        </div>
        <v-btn icon="mdi-close" variant="text" :aria-label="$t('app.actions.close')" @click="previewOpen = false" />
      </div>
      <div class="platform-email__preview-body">
        <iframe :title="$t('admin.platformEmail.templates.previewTitle')" :srcdoc="preview?.html || ''" sandbox="" />
        <h3>{{ $t("admin.platformEmail.templates.textPreview") }}</h3>
        <pre>{{ preview?.text }}</pre>
      </div>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
import platformEmailTemplatesLogic from "./platformEmailTemplatesLogic.mjs";

export default {
  name: "PlatformEmailTemplatesCard",
  ...platformEmailTemplatesLogic,
};
</script>

<style scoped src="./platformEmail.css"></style>
